export const ADD_BLOG                   = 'ADD_BLOG';
export const UPDATE_BLOG                = 'UPDATE_BLOG';

export const GET_BLOG                   = 'GET_BLOG';
export const RESULT_GET_BLOG            = 'RESULT_GET_BLOG';

export const GET_BLOG_DETAILS           = 'GET_BLOG_DETAILS';
export const RESULT_GET_BLOG_DETAILS    = 'RESULT_GET_BLOG_DETAILS';
export const CLEAR_BLOG_DETAILS         = 'CLEAR_BLOG_DETAILS';

export const REMOVE_BLOG                = 'REMOVE_BLOG';
export const RESULT_REMOVE_BLOG         = 'RESULT_REMOVE_BLOG';